import './App.css';
//import 'bootstrap/dist/css/bootstrap.min.css';
import TrackingForm from './trackingForm.tsx';

function App() {
  return (
    <div className="App">
      <TrackingForm />
    </div>
  );
}

export default App;
